/*globals window, document */

define('popupController',['jquery'], function($) {
    return {
        init: function() {
            "use strict";
            var currentPopupFocus; // element that had focus before popup was opened
            /**
             * Close popup, detach key events for popup, and return focus to element that had it
             * before popup was opened.
             */
            function closePopup(id, currentPopupFocus) {
                $("#" + id).hide();
                $(document).off('keydown.popuptab');
                $(currentPopupFocus).focus();
            }

            /**
             * Open popup, lock tabbing to popup, attach ESC keypress to popup close.
             */
            $(document).on("click", ".promoTileLegalCopy a", function(e) {
                var popupContainer;

                if ($(this).attr("href") && $(this).attr("href") !== "#") {
                    return; // Do default
                }

                e.preventDefault();

                popupContainer = $("#legalPopup-" + $(this).parent().attr("id").split("-")[1] + " .cta-popup");
                popupContainer.css("top", Math.max(100, window.pageYOffset));
                $("#legalPopup-" + $(this).parent().attr("id").split("-")[1]).show();



                currentPopupFocus = document.activeElement;
                popupContainer.find('a,*[tabindex]').filter(':visible:first').focus();

                //set role for accessibility
                popupContainer.attr('role', 'dialog');
                popupContainer.attr('title', '');

                $(document).off('keydown.popuptab').on('keydown.popuptab', function(e) {
                    var keyCode = e.keyCode || e.which;

                    if (e.shiftKey && keyCode === 9 && (document.activeElement === popupContainer.find('a,input,textarea,button,*[tabindex]').filter(':visible:first')[0] || document.activeElement === $('body')[0])) {
                        popupContainer.find('a,input,textarea,button,div[tabindex]').filter(':visible:last').focus();
                        e.preventDefault();
                    } else if (!e.shiftKey && keyCode === 9 && (document.activeElement === popupContainer.find('a,input,textarea,button,*[tabindex]').filter(':visible:last')[0] || document.activeElement === $('body')[0])) {
                        popupContainer.find('a,input,textarea,button,div[tabindex]').filter(':visible:first').focus();
                        e.preventDefault();
                    } else if (keyCode === 27) {
                        closePopup(popupContainer.parent().attr("id"), currentPopupFocus);
                    }
                });
            });


            /**
             * Call close popup.
             */
            $(document).on("click", ".pop-up-container .legal-popup a.close-btn", function(e) {
                e.preventDefault();
                closePopup($(this).parent().parent().attr("id"), currentPopupFocus);
            });
        }
    };
});

